// Renders a red text

const ErrorMessage = ({ msg }: { msg: any }) => (
    msg
        ? <span className="error-message">{msg}</span>
        : null
);

export default ErrorMessage;